import React, { Component } from 'react'
import FrogHead3 from '../assets/Frog_Head_4.png';
export class HomePanel extends Component {
    render() {
        return (
            <div className="home-panel">
            <img src={FrogHead3} className="frog-img" alt="" />
                <div className="home-subpanel">
                    <h1>What is NFrogTz</h1>
                    <span>SpaceBudz is an NFT platform on the Cardano blockchain. 10,000 SpaceBudz are in existence and each astronaut is unique and only owned by you. Animals, robots and other mysterious creatures with different features and properties await you!
                    </span>
                </div>
                
            </div>
        )
    }
}

export default HomePanel
